
<div 
    class="buttons" 
    [class.is-inline]="isInline"
    [class.is-block]="!isInline"
>
    <button (click)="editStart()"  *ngIf="!model.isEditing" [class.is-small]="isInline" [disabled]="isDisabled" class="button"><tra [slug]="caption"></tra></button>
    <button (click)="editCancel()" *ngIf="model.isEditing"  [class.is-small]="isInline" [disabled]="model.isSaving || isDisabled" class="button"><tra slug="btn_cancel"></tra></button>
    <button (click)="editSave()"   *ngIf="model.isEditing"  [class.is-small]="isInline" [disabled]="model.isSaving || isDisabled" class="button is-success"><tra slug="btn_save"></tra></button>
</div>